// Topic cluster architecture for the Knowledge Hub (pillar & spokes)
export const KNOWLEDGE_CLUSTERS = [
  {
    id: 'expansion',
    title: 'Expansion & tryckhållning',
    description:
      'Rätt dimensionerat expansionskärl är skillnaden mellan ett stabilt system och återkommande larm. Här går vi igenom teorin bakom slutna expansionskärl enligt SS-EN 12828, en praktisk fältchecklista och hur du skyddar systemet mot tryckslag.',
    slugs: [
      'dimensionering-av-slutna-expansionskarl',
      'sa-dimensionerar-du-expansionskarl-steg-for-steg',
      'tryckslag-i-rorsystem',
    ],
    calculators: [{ name: 'Expansionskärl-kalkylator (SS-EN 12828)', href: '/dimensionering/expansionskarl' }],
    category: { name: 'Expansionssystem', href: '/produkter/kategori/expansionssystem' },
  },
  {
    id: 'tankar',
    title: 'Tankdimensionering',
    description:
      'Ackumulatortankar jämnar ut effekttoppar, förlänger pannans livslängd och möjliggör smart energilagring. Lär dig dimensionera volym och skiktning – och använd våra verktyg för både standardtankar och specialtankar.',
    slugs: ['dimensionering-av-ackumulatortank', 'vanliga-fragor-om-ackumulatortankar'],
    calculators: [
      { name: 'Ackumulatortank-kalkylator', href: '/dimensionering/ackumulatortank' },
      { name: 'Designa specialtank', href: '/dimensionering/specialtank' },
    ],
    category: { name: 'Tankar & Elpannor', href: '/produkter/kategori/tankar' },
  },
  {
    id: 'vvx-pumpar',
    title: 'Värmeväxlare & pumpval',
    description:
      'Värmeväxlarens LMTD och pumpens driftpunkt på systemkurvan avgör hela systemets verkningsgrad. Här hittar du metodiken för att räkna rätt från början.',
    slugs: ['dimensionering-av-varmevaxlare', 'pumpval-och-systemkurvor'],
    calculators: [],
    category: { name: 'Värmeväxlare', href: '/produkter/kategori/varmevaxlare' },
    extraCategories: [{ name: 'Pumpar', href: '/produkter/kategori/pumpar' }],
  },
  {
    id: 'injustering',
    title: 'Injustering & reglerventiler',
    description:
      'Kv-värden, ventilauktoritet och tryckklasser – korrekt injustering sänker energianvändningen och löser klagomål på ojämn värme. Guiderna täcker allt från styrventiler till lågtemperaturdrift.',
    slugs: [
      'injustering-av-storre-varmesystem',
      'styrventiler-kv-dimensionering-och-ventilauktoritet',
      'lagtemperaturdrift-i-befintliga-varmesystem',
      'pn6-vs-pn10-vs-pn16-skillnaden-mellan-tryckklasser-vvs',
    ],
    calculators: [],
    category: { name: 'Ventiler', href: '/produkter/kategori/ventiler' },
  },
  {
    id: 'tappvatten',
    title: 'Tappvatten, flöde & mätning',
    description:
      'Tappvarmvatten, VVC-slingor och tryckfallsberäkning i rörnät – med rätt flödesdata och mätare får du både komfort och legionellasäkerhet.',
    slugs: [
      'dimensionering-av-tappvarmvatten-och-vvc',
      'tryckfallsberakning-i-rornat',
      'val-av-vattenmatare-mid-klasser-r-tal-dimensionering',
    ],
    calculators: [],
    category: { name: 'Mätare', href: '/produkter/kategori/matare' },
  },
  {
    id: 'aterstromning',
    title: 'Regelefterlevnad & återströmningsskydd',
    description:
      'SS-EN 1717 ställer tydliga krav på skydd av dricksvatten. Lär dig vätskekategorierna och när typ BA, CA eller EA krävs.',
    slugs: ['aterstromningsskydd-enligt-ss-en-1717'],
    calculators: [],
    category: { name: 'Återströmning', href: '/produkter/kategori/aterstromning' },
  },
];

// Authority/trust content that intentionally sits outside the clusters
export const TRUST_SLUGS = ['fem-djupa-vvs-fragor-forskning-och-haverier'];

export const getClusterForSlug = (slug) =>
  KNOWLEDGE_CLUSTERS.find((c) => c.slugs.includes(slug)) || null;
